import { render, staticRenderFns } from "./tabObjectReports.vue?vue&type=template&id=6b8648e3&"
import script from "./tabObjectReports.vue?vue&type=script&lang=js&"
export * from "./tabObjectReports.vue?vue&type=script&lang=js&"
import style0 from "./tabObjectReports.vue?vue&type=style&index=0&id=6b8648e3&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports